import React, { useContext, useReducer, useCallback, useEffect } from "react"
import { useHistory } from "react-router-dom"
import axios from "axios"
import { useTranslation } from "react-i18next"

import { CircularProgress } from '@material-ui/core'
import Pagination from "@material-ui/lab/Pagination"

import ErrorBoundary from '../../Utils/ErrorBoundary'
import AuthContext from "../../../context/auth-context"
import { useStateConnectedToCache, dataFetchReducer } from "../../Utils/requestUtils"
import Filter from "./Filter/Filter"
import FaceDatabaseValidationCard from "./FaceDatabaseValidationCard/FaceDatabaseValidationCard"

function FaceDatabaseValidationInbox(props) {
    const { t } = useTranslation()
    const history = useHistory()
    const user_data = useContext(AuthContext).user_data

    if (!user_data.roles.includes("read_face_database_validations")) {
        history.push("")
    }

    let local_storage_object_preffix = "newAccountEventEvent"

    const [pageParams, setPageParams] = useStateConnectedToCache(local_storage_object_preffix)

    const [pageState, dispatchPageState] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    )

    const doRequest = useCallback(
        (payload) => {
            dispatchPageState({ type: "data_fetch_init" })
            axios.get("/dash/account_event/face_database_validations", {
                params: payload
            }).then(response => {
                dispatchPageState({
                    type: "data_fetch_success",
                    payload: response.data
                })
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchPageState({ type: "data_fetch_failure_403" })
                else if ((error.response || {}).status === 404) dispatchPageState({ type: "data_fetch_failure_404" })
                else dispatchPageState({ type: "data_fetch_failure" })
            })
        }, []
    )

    useEffect(() => {
        let payload = {
            "page_number": pageParams.page - 1,
            "page_rows": 15
        }
        Object.keys(pageParams.filters).forEach((key) => {
            payload[key] = pageParams.filters[key]
        })
        const timer_ = setTimeout(() => {
            doRequest(payload)
        }, 300);
        const timer_2 = setInterval(() => {
            doRequest(payload)
        }, 60000);
        return () => {
            clearTimeout(timer_)
            clearInterval(timer_2)
        }
    }, [doRequest, pageParams])

    const handleChangePage = (event, page) => {
        if (pageState.page === page) return
        setPageParams({ page: page, filters: pageParams.filters })
    }

    const contentContainer = (dataList) => {
        let itensCount = dataList['data'].length

        if (itensCount === 0) {
            return (
                <div className='emptyContainer'>
                    <p className={["blueText", "subtitleSize"].join(" ")}>
                        {t("Nenhum evento encontrado")}
                    </p>
                </div>
            )
        }

        let cards = dataList['data'].map((event) => (
            <ErrorBoundary key={event.event_key}>
                <FaceDatabaseValidationCard event={event} />
            </ErrorBoundary>
        ))

        return (
            <div className='cardContainer'>
                <div className="listCardHeader">
                    <div
                        className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                        style={{ flex: "2 1 120px", textAlign: "center" }}
                    >
                        ID
                    </div>
                    {user_data.business_group_key &&
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "2 1 200px", textAlign: "center" }}
                        >
                            Cliente
                        </div>
                    }
                    <div
                        className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                        style={{ flex: "1 1 145px", textAlign: "center" }}
                    >
                        Documento
                    </div>
                    <div
                        className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                        style={{ flex: "1 1 45px", textAlign: "center" }}
                    >
                        Status
                    </div>
                    <div
                        className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                        style={{ flex: "1 1 110px", textAlign: "center" }}
                    >
                        Data
                    </div>
                </div>
                {cards}
            </div>
        )
    }

    if (pageState.fetchedData) {
        return (
            <div style={{ width: "auto", paddingBottom: "30px" }}>
                <div style={{ display: "flex" }}>
                    <p className={["blueText", "titleSize"].join(" ")}>{t("account_event_face_database_validation")}</p>
                </div>
                <ErrorBoundary doNothing><Filter local_storage_object_preffix={local_storage_object_preffix} setPageParams={setPageParams} /></ErrorBoundary>
                <div>{contentContainer(pageState.fetchedData)}</div>
                <div>
                    <Pagination
                        className="pagination"
                        page={pageParams.page}
                        count={parseInt(pageState.fetchedData["number_of_pages"])}
                        onChange={(e, page) => handleChangePage(e, page)}
                    />
                </div>
            </div>
        )
    } else if (pageState.isError) {
        return (
            <div style={{ width: "auto" }}>
                <p className={["blueText", "titleSize"].join(" ")}>{t("account_event_face_database_validation")}</p>
                <div style={{ height: "55vh", display: "flex" }}>
                    <p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
                        {pageState.errorMessage}
                    </p>
                </div>
            </div>
        )
    } else if (pageState.isLoading) {
        return (
            <div style={{ width: "auto" }}>
                <p className={["blueText", "titleSize"].join(" ")}>{t("account_event_face_database_validation")}</p>
                <div className="circularProgressCenter">
                    <CircularProgress />
                </div>
            </div>
        )
    }

    return <div>account event</div>
}

export default FaceDatabaseValidationInbox
